import { useGetCustomerQuery } from "@/api/customer"

export const useCustomer = () => {
  const { data: customer } = useGetCustomerQuery()

  return {
    customer,
    isReseller: customer?.isReseller || false,
  }
}